<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'UserLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '裁判员管理'
            },
            {
              key: '2',
              title: '教练员管理'
            },
            {
              key: '3',
              title: '运动员管理'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/user/caipanList':
                return '1'
              case '/user/jiaolianList':
                return '2'
              case '/user/yundongyuanList':
                return '3'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/user/caipanList')
                break
              case '2':
                this.$router.push('/user/jiaolianList')
                break
              case '3':
                this.$router.push('/user/yundongyuanList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
